export const EMAIL_NOT_SENT = 'EMAIL_NOT_SENT'
export const PENDING = 'PENDING'
export const ACTIVE = 'ACTIVE'
export const DISABLED = 'DISABLED'

// Deprecated
export const VALIDATED = 'VALIDATED'
